import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

//import Shiffy from './assets/shiffy-business.svg';
import Shiffy from './assets/Master-Shyft-Logo.svg';

import './AdminClaimComponent.scss';

const AdminClaimComponent = ({ userPrivilege, claim }) => (
  <div className="onboarding-wrapper">
    <div className="welcome-onboarding">
      <h1 className="headline">Welcome to Shyft</h1>

      <p className="description">
        Congrats on joining your team in Shyft. Admins use the web app to create
        schedules and share them with their teams. Team Members use the mobile app
        to view their schedules and swap shifts.
      </p>

      <p className="download-prompt">
        Download Shyft and login on mobile to continue
      </p>

      <div className="modal-buttons">
        <a
          href="https://apps.apple.com/us/app/shyft-shift-swap-schedule/id730422337"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/img/app-store-badge.png" alt="Download on the App Store" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.coffeeenterprise"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/img/google-play-badge.png" alt="Get it on Google Play" />
        </a>
      </div>

      <div className="admin-note">
        <p className="admin-title">Need Admin Access To The Web App?</p>
        <p className="admin-info">
          Ask your location manager to assign Admin privileges to your account in the
          User Management section. Once that is completed, you can refresh this page
          and create schedules for your team.
        </p>
      </div>
    </div>
  </div>
);

export { AdminClaimComponent };
